import { ComponentProps } from 'react';
import { Dimensions, Platform, StyleSheet } from 'react-native';
import { ContentLoader, Rect, Circle } from '@pletly/ui';

const Loader = (props: ComponentProps<typeof ContentLoader>) => (
	<ContentLoader
		key="7"
		speed={2}
		width={Dimensions.get('window').width}
		height={667}
		viewBox="0 0 375 667"
		backgroundColor="#E8E7E1"
		foregroundColor="#ecebeb"
		style={styles.root}
		{...props}
	>
		<Circle cx="36" cy="120" r="20" />
		<Rect x="64" y="122" rx="3" ry="3" width="210" height="15" />
		<Rect x="63" y="103" rx="3" ry="3" width="133" height="15" />
		<Rect x="14" y="145" rx="0" ry="0" width="345" height="343" />
		<Circle cx="32" cy="513" r="16" />
		<Circle cx="74" cy="513" r="16" />
		<Rect x="16" y="542" rx="3" ry="3" width="70" height="14" />
		<Rect x="16" y="571" rx="3" ry="3" width="342" height="16" />
	</ContentLoader>
);

export default Loader;

const styles = StyleSheet.create({
	root: {
		/*
			TODO can be changed to string value when
			https://github.com/software-mansion/react-native-svg/issues/1740 fixed
		*/
		...Platform.select({
			native: { transform: [{ translateY: -80 }] },
			web: { transform: 'translateY(-80px)' },
		}),
	},
});
